// PRD 01 §4.3 update-time format: `YYYY. M. DD. HH:MM` (month unpadded, time padded) —
// mirrors the prototype's home.js formatter. Sourced from the data field, never the client clock.
export function formatUpdatedAt(iso: string | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}. ${d.getMonth() + 1}. ${d.getDate()}. ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
